import { JuchuData } from '../../common/objectType/JuchuData';
import { JuchuDetailData } from '../../common/objectType/JuchuDetailData';

export const JuchuDataToArray = (
  jishaKbn: String,
  shoriSentaku: String,
  companyCd: String,
  accountId: String,
  object: JuchuData
) => {
  var array: any[] = [];
  array.push({
    adrBan: object.adrBan,
    adrKenCd: object.adrKenCd,
    adrSiCd: object.adrSiCd,
    adrTyo: object.adrTyo,
    chartFlg: object.chartFlg,
    haisoMemo: object.haisoMemo,
    jyuDt: object.jyuDt,
    jyuNo: object.jyuNo,
    kaitoMemo: object.kaitoMemo,
    kenNm: object.kenNm,
    kiboDt: object.kiboDt,
    kiboKbn: object.kiboKbn,
    kojiNm: object.kojiNm,
    kojiNo: object.kojiNo,
    ktnNm: object.ktnNm,
    nouCd: Math.abs(object.nouCd ? object.nouCd : 0),
    nouNm: object.nouNm,
    okuriMemo: object.okuriMemo,
    renMemo: object.renMemo,
    siNm: object.siNm,
    ttyumonNo: object.ttyumonNo,
    tanNm: object.tanNm,
    telNo: object.telNo,
    tokCd: object.tokCd,
    tokCd2: object.tokCd2,
    tokNm: object.tokNm,
    tokkaFlg: object.tokkaFlg,
    userCd: object.userCd,
    userCd2: object.userCd2,
    userNm: object.userNm,
    jishaKbn: jishaKbn,
    shoriSentaku: shoriSentaku,
    companyCd: companyCd,
    accountId: accountId,
    nonyuTel: object.nonyuTel,
    nonyuYubin: object.nonyuYubin,
    updDt: object.updDt,
  });
  return array;
};

export const JuchuDetailDataToArray = (
  tokCd: String,
  tokCd2: String,
  juchuListData: JuchuDetailData[]
) => {
  var array: any[] = [];
  for (let index = 0; index < juchuListData.length; index++) {
    array.push({
      dispNo: juchuListData[index].dispNo,
      jyugyoNo: juchuListData[index].jyugyoNo,
      hinCd: juchuListData[index].hinCd,
      hinNm: juchuListData[index].hinNm,
      hinKbn: juchuListData[index].hinKbn,
      irogNm: juchuListData[index].irogNm,
      irogCd: juchuListData[index].irogCd,
      irime: juchuListData[index].irime,
      irimeKbn: juchuListData[index].irimeKbn,
      irimeNm: juchuListData[index].irimeNm,
      tuyaCd: juchuListData[index].tuyaCd,
      tuyaNm: juchuListData[index].tuyaNm,
      hinSize: juchuListData[index].hinSize,
      hinShape: juchuListData[index].hinShape,
      hinJoint: juchuListData[index].hinJoint,
      hinSizeNm: juchuListData[index].hinSizeNm,
      hinShapeNm: juchuListData[index].hinShapeNm,
      hinJointNm: juchuListData[index].hinJointNm,
      hyoujiIroCd: juchuListData[index].hyoujiIroCd,
      kihonIroCd: juchuListData[index].kihonIroCd,
      jyuSu: juchuListData[index].jyuSu,
      nisugataKbn: juchuListData[index].nisugataKbn,
      nisugataNm: juchuListData[index].nisugataNm,
      kaitoDt: juchuListData[index].kaitoDt,
      kaitoKbn: juchuListData[index].kaitoKbn,
      ampmNm: juchuListData[index].ampmNm,
      kaijyoKbn: juchuListData[index].kaijyoKbn,
      kaitoNm: juchuListData[index].kaitoNm,
      haiCd: juchuListData[index].haiCd,
      haiCd2: juchuListData[index].haiCd2,
      haiNm: juchuListData[index].haiNm,
      haiUrlMae: juchuListData[index].haiUrlMae,
      haiUrlAto: juchuListData[index].haiUrlAto,
      okuriNo: juchuListData[index].okuriNo,
      syukkaDt: juchuListData[index].syukkaDt,
      mihonNo: juchuListData[index].mihonNo,
      geniraiKbn: juchuListData[index].geniraiKbn,
      genbutuNo: juchuListData[index].genbutuNo,
      iroBiko: juchuListData[index].iroBiko,
      biko: juchuListData[index].biko,
      iroKbn: juchuListData[index].iroKbn,
      setKbn: juchuListData[index].setKbn,
      processKbn: juchuListData[index].processKbn || '0',
      tokCd: tokCd,
      tokCd2: tokCd2,
    });
  }
  return array;
};
